import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface FloatingMessageTextProps {
  children: React.ReactNode;
}

const TextComponent: React.FC<FloatingMessageTextProps> = ({ children }) => {
  return <span className="peptalk-floating-message-text">{children}</span>;
};

export const Text: React.FC<FloatingMessageTextProps> = (
  props: FloatingMessageTextProps
) => {
  const Component = useCustomComponent({
    componentName: 'FloatingMessageText',
    Component: TextComponent,
  });

  return <Component {...props} />;
};
